<script>
import LoyaltyCardFrame from '@/frames/loyaltyCardFrame'
import StoreLoyaltyCardFrame from '@/frames/storeLoyaltyCardFrame'
import ViewTitle from '@/components/ViewTitle'
import LoyaltyCardStoreBalanceCard from '@/components/LoyaltyCardStoreBalanceCard'
import WideIconTile from '@/components/WideIconTile'
import DialogUtils from '@/utils/dialogUtils'
import LoyaltyCardsService from '@/services/loyaltyCards'
import EnvironmentUtils from '@/utils/environmentUtils'

export default
{
    name: 'loyalty-card-store-page',

    created ()
    {
        LoyaltyCardFrame.initFrame(this.$store)
        StoreLoyaltyCardFrame.initFrame(this.$store, this.storeId)
    },

    render () 
    {
        if (!this.store || !this.storeConfig) return

        return (
            <div id='loyalty-card-store-page-view'>
                <view-title back-action={true}>Dépenser mes points</view-title>
                <loyalty-card-store-balance-card store={this.store} store-config={this.storeConfig} balance={this.balance} />
                <div class='help-text'>Cliquez sur la récompense de votre choix pour continuer</div>
                {
                    this.storeRewards.map(r =>
                    {
                        return <wide-icon-tile key={r.rewardName} title={r.rewardName} on-click={() => this.onRewardClicked(r)} right-content={r.rewardPrice + ' pts'}
                            disabled={r.rewardPrice > this.balance.points} on-click-disabled={() => this.$toast.warning('Votre solde est insuffisant')} />
                    })
                }
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    computed:
    {
        storeId ()
        {
            return this.$route.params.storeId
        },

        card ()
        {
            return this.$store.state.loyaltyCard.card
        },

        balance ()
        {
            return this.card.balance.find(b => b.storeId == this.storeId)
        },

        store ()
        {
            return this.$store.getters.stores.getStoreById(this.storeId)
        },

        storeConfig ()
        {
            return this.$store.state.storeLoyaltyCard.storeConfigs[this.store.id]
        },

        storeRewards ()
        {
            return this.$store.state.storeLoyaltyCard.storeRewards[this.store.id]
        }
    },

    methods:
    {
        async onRewardClicked (reward)
        {
            const confirmed = await DialogUtils.waitForUserConfirmationAsync
            ({
                title: 'Voulez-vous vraiment effectuer cette action ?',
                description: `Votre carte sera débitée de <b>${reward.rewardPrice} points</b> en échange de <b>${reward.rewardName}</b>.<br/>Souhaitez-vous continuer ?`,
                isDanger: false
            })
            if (!confirmed) return

            window.app.showFullscreenSpinner = true

            const card = await LoyaltyCardsService.redeemReward(EnvironmentUtils.cityId, this.$store.state.user.token, this.card.cardId, reward.rewardId)
            this.$store.commit('loyaltyCard/setCard', card)

            window.app.showFullscreenSpinner = false

            this.$router.push({ name: 'LoyaltyCardRewardRedeemed', params:{rewardId: reward.rewardId} })
        }
    },

    components:
    {
        ViewTitle,
        LoyaltyCardStoreBalanceCard,
        WideIconTile
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#loyalty-card-store-page-view
{
    display: flex;
    flex-direction: column;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);
    margin-left: 10px;
    margin-right: 10px;
    min-height: 90vh;

    .OnTablet({
        margin-left: auto;
        margin-right: auto;
        max-width: 550px;
    });
    .OnDesktop({ margin-top: 8vh; });

    .help-text
    {
        margin-top: 30px;
        margin-bottom: 10px;
        font-size: 14px;
    }

    .wide-icon-tile
    {
        margin-top: 5px;

        .header
        {
            .right
            {
                width: 25%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/LoyaltyCardStorePage.vue